import { Component,HostListener  } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router,NavigationEnd  } from '@angular/router';
import { Configuration } from './app.constants';
import { ServerapiService } from './serverapi.service';
import { AuthenticationService } from './_services/authentication.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'CLIENT';
  currentUser: number;
  configurations: any;
  loginUserName;
  showScrollButton = false;

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private fb: FormBuilder,
    private serverapi: ServerapiService,
    private configuration: Configuration
  ) {
    this.currentUser = Number(localStorage.getItem('currentLoingUserId'));
  }

  headerForm = this.fb.group({
    patientService: ['']
  });

  // tslint:disable-next-line:use-lifecycle-interface
  ngOnInit() {
    document.documentElement.scrollTop = 0;
    this.currentUser = Number(localStorage.getItem('currentLoingUserId'));
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {

    if (window.pageYOffset > 200) {
      this.showScrollButton = true;
    } else {
      this.showScrollButton = false;
    }
  }
scrollToTop() {

  const duration = 800;
  const start = window.pageYOffset;
  const startTime = performance.now();

  const easeOutCubic = (t) => {
    return 1 - Math.pow(1 - t, 3);
  };

  const animation = (currentTime) => {

    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);

    window.scrollTo(0, start * (1 - easeOutCubic(progress)));

    if (progress < 1) {
      requestAnimationFrame(animation);
    }
  };

  requestAnimationFrame(animation);
}

  setLoginValues() {
    this.currentUser = Number(localStorage.getItem('currentLoingUserId'));
    this.loginUserName = localStorage.getItem('chiefAdmin');

  }

  logout() {
    this.authenticationService.logout();
    localStorage.clear();
    this.currentUser = 0;
  }
  accessApplication(event: any) {
    this.serverapi.getUserFullDetailByName(localStorage.getItem('portalUserName')).subscribe(data => {
      if (data) {
        console.log(data);
        if (event.target.value === 'oncocareDigital') {
          window.location.href = this.configuration.SERVER.oncocareDigitalApplicationUrl + '#/doctor';
        } else if (event.target.value === 'oncocareDatabase') {
          window.location.href = this.configuration.SERVER.oncocareDatabaseApplicationUrl + '#/app/user/user-dashboard';
        }
      }
    }, error => console.log(error));
  }
}



